import { render, staticRenderFns } from "./rtbox.vue?vue&type=template&id=328fe626&scoped=true&"
import script from "./rtbox.vue?vue&type=script&lang=js&"
export * from "./rtbox.vue?vue&type=script&lang=js&"
import style0 from "./rtbox.vue?vue&type=style&index=0&id=328fe626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328fe626",
  null
  
)

export default component.exports